<ng-template [vbCssRules]="cssRules" [id]="'sidebar-layout-styles'"></ng-template>

<ng-content select="[slot='sidebar']"></ng-content>

<div flex="fill" [ngClass]="styles.mainContentSlot">
	<ng-content select="[slot='mainContent']"></ng-content>
</div>
